__turbopack_context__.v({
  "backgroundImage": "OurPeople-module-scss-module__I919Dq__backgroundImage",
  "backgroundLayer": "OurPeople-module-scss-module__I919Dq__backgroundLayer",
  "bgPosition1": "OurPeople-module-scss-module__I919Dq__bgPosition1",
  "bgPosition2": "OurPeople-module-scss-module__I919Dq__bgPosition2",
  "body": "OurPeople-module-scss-module__I919Dq__body",
  "heading": "OurPeople-module-scss-module__I919Dq__heading",
  "inner": "OurPeople-module-scss-module__I919Dq__inner",
  "ourPeople": "OurPeople-module-scss-module__I919Dq__ourPeople",
  "position1": "OurPeople-module-scss-module__I919Dq__position1",
  "position2": "OurPeople-module-scss-module__I919Dq__position2",
  "position3": "OurPeople-module-scss-module__I919Dq__position3",
  "primaryImage": "OurPeople-module-scss-module__I919Dq__primaryImage",
  "primaryImageContainer": "OurPeople-module-scss-module__I919Dq__primaryImageContainer",
  "stack-module-0": "OurPeople-module-scss-module__I919Dq__stack-module-0",
  "stack-module-1": "OurPeople-module-scss-module__I919Dq__stack-module-1",
  "stack-module-10": "OurPeople-module-scss-module__I919Dq__stack-module-10",
  "stack-module-11": "OurPeople-module-scss-module__I919Dq__stack-module-11",
  "stack-module-12": "OurPeople-module-scss-module__I919Dq__stack-module-12",
  "stack-module-13": "OurPeople-module-scss-module__I919Dq__stack-module-13",
  "stack-module-14": "OurPeople-module-scss-module__I919Dq__stack-module-14",
  "stack-module-15": "OurPeople-module-scss-module__I919Dq__stack-module-15",
  "stack-module-16": "OurPeople-module-scss-module__I919Dq__stack-module-16",
  "stack-module-17": "OurPeople-module-scss-module__I919Dq__stack-module-17",
  "stack-module-18": "OurPeople-module-scss-module__I919Dq__stack-module-18",
  "stack-module-19": "OurPeople-module-scss-module__I919Dq__stack-module-19",
  "stack-module-2": "OurPeople-module-scss-module__I919Dq__stack-module-2",
  "stack-module-20": "OurPeople-module-scss-module__I919Dq__stack-module-20",
  "stack-module-3": "OurPeople-module-scss-module__I919Dq__stack-module-3",
  "stack-module-4": "OurPeople-module-scss-module__I919Dq__stack-module-4",
  "stack-module-5": "OurPeople-module-scss-module__I919Dq__stack-module-5",
  "stack-module-6": "OurPeople-module-scss-module__I919Dq__stack-module-6",
  "stack-module-7": "OurPeople-module-scss-module__I919Dq__stack-module-7",
  "stack-module-8": "OurPeople-module-scss-module__I919Dq__stack-module-8",
  "stack-module-9": "OurPeople-module-scss-module__I919Dq__stack-module-9",
  "textContent": "OurPeople-module-scss-module__I919Dq__textContent",
  "z-base": "OurPeople-module-scss-module__I919Dq__z-base",
  "z-content": "OurPeople-module-scss-module__I919Dq__z-content",
  "z-footer": "OurPeople-module-scss-module__I919Dq__z-footer",
  "z-header": "OurPeople-module-scss-module__I919Dq__z-header",
  "z-hero": "OurPeople-module-scss-module__I919Dq__z-hero",
  "z-logo": "OurPeople-module-scss-module__I919Dq__z-logo",
  "z-logo-effect": "OurPeople-module-scss-module__I919Dq__z-logo-effect",
  "z-navigation": "OurPeople-module-scss-module__I919Dq__z-navigation",
  "z-sub": "OurPeople-module-scss-module__I919Dq__z-sub",
});
